module.exports = __webpack_public_path__ + "static/coach-hire-services-theatre-concerts-cultural-events-132e055fba0547f5bdc8e4049dbeb03c.jpg";